import { Navigate, Outlet, useLocation, useSearchParams } from 'react-router-dom';
import { Spin } from 'antd';

import { resolveLoginTarget } from '@/layouts/mobile-access';
import { useIsMobile } from '@/hooks/useIsMobile';
import { useAuthStore } from '@/stores/auth';

/** 首次打开惰性路由时提供可见的加载反馈。 */
export function RouteLoading() {
  return (
    <div className="flex min-h-dvh items-center justify-center gap-3" role="status">
      <Spin />
      <span>正在加载页面…</span>
    </div>
  );
}

/** 认证路由守卫：未登录跳转 /login */
export function RequireAuth() {
  const location = useLocation();
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  if (!isAuthenticated) {
    const returnTo = location.pathname + location.search + location.hash;
    return <Navigate to={`/login?${new URLSearchParams({ returnTo })}`} replace />;
  }
  return <Outlet />;
}

/** 公开路由守卫：已登录按权限跳转落地页 */
export function PublicOnly() {
  const mobile = useIsMobile();
  const [params] = useSearchParams();
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const permissions = useAuthStore((s) => s.permissions);
  if (isAuthenticated) {
    return (
      <Navigate to={resolveLoginTarget(params.get('returnTo'), permissions, mobile)} replace />
    );
  }
  return <Outlet />;
}
